import * as React from 'react';

// From Rails Props:
const initialRailsPropsContext = {
  verificationUrl: '/',
};

export const RailsPropsContext = React.createContext(initialRailsPropsContext);

export const railsPropsConsumer = <P extends IRailsProps>(Component: React.ComponentType<P>) => (props: P & IRailsProps & any) => (
  <RailsPropsContext.Consumer>
    {context => <Component {...props} context={context} />}
  </RailsPropsContext.Consumer>
);

export interface IRailsProps {
  verificationUrl?: string;
}

// FundsApp:
const initialFundsAppContext = {
  appLink: '/',
};

export const FundsAppContext = React.createContext<IFundsAppContext>(initialFundsAppContext);

export const fundsAppConsumer = <P extends object>(Component: React.ComponentType<P>) => (props: P & IFundsAppContext) => (
  <FundsAppContext.Consumer>
    {context => <Component {...props} context={context} />}
  </FundsAppContext.Consumer>
);

export interface IFundsAppContext {
  appLink: string;
  investorId?: number;
}

// Context to update state by dispatch in Funds
export const FundsDispatchContext = React.createContext<React.Dispatch<object>>(() => {});
